import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import Logo from 'components/atoms/logo/index.jsx';
import CompanyInfo from 'components/atoms/companyInfo/index.jsx';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class Header extends Component {
  render() {
    var type = this.props.type || '';
    var brand = this.props.brand || 'territorio';
    var inFlow = this.props.inFlow;

    let className = cx({
      header: true,
      [`${type}`]: true,
      inFlow: inFlow,
    });
    return (
      <div className={classnames(className)}>
        <div className="container">
          <div className="logo">
            <Link to="/">
              <Logo brand={brand} />
            </Link>
          </div>

          <CompanyInfo brand={brand} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    brand: state.configuration.brand,
  };
};

export default connect(mapStateToProps)(Header);
